import React from "react";
import { Route, Routes } from "react-router-dom";
import { AdminScheduledReportsPage } from "./AdminScheduledReportsPage";
import {DistributionListPage} from "./DistributionListPage";

export const ScheduledReportsRouter: React.FC = () => (
  <Routes>
    <Route path="/" element={<AdminScheduledReportsPage />} />
    <Route path="/distribution-list" element={<DistributionListPage />} />
  </Routes>
);
